// extracted by mini-css-extract-plugin
export default {"orderBtn":"NavBarButtonModal_orderBtn__IVRxE","buttons":"NavBarButtonModal_buttons__MJgCe"};